import styled from '@emotion/styled';
import { greys, white } from '@/styles/colors';

const INK = '#0b0f19';
const MUTED = '#4b5563';

const NOTICE_TONES = {
    on: { background: '#f0fdf4', border: '#86efac', tag: '#16a34a' },
    bad: { background: '#fef2f2', border: '#fca5a5', tag: '#dc2626' },
};

export const Panel = styled.div`
    display: flex;
    flex-direction: column;
    gap: 24px;
    padding: 24px;
`;

export const HeaderBadge = styled.span`
    background: ${INK};
    border-radius: 6px;
    color: ${white.primary};
    font-size: 11px;
    font-weight: 700;
    margin-left: auto;
    padding: 4px 8px;
`;

export const NoticeCard = styled.div`
    align-items: center;
    background: ${({ tone }) => NOTICE_TONES[tone].background};
    border: 1px solid ${({ tone }) => NOTICE_TONES[tone].border};
    border-radius: 12px;
    display: flex;
    gap: 16px;
    padding: 16px;
`;

export const NoticeTag = styled.span`
    background: ${({ tone }) => NOTICE_TONES[tone].tag};
    border-radius: 6px;
    color: ${white.primary};
    flex-shrink: 0;
    font-size: 12px;
    font-weight: 800;
    padding: 4px 8px;
    white-space: nowrap;
`;

export const NoticeText = styled.div`
    display: flex;
    flex: 1;
    flex-direction: column;
    gap: 2px;
    min-width: 0;
`;

export const NoticeTitle = styled.span`
    color: ${INK};
    font-size: 14px;
    font-weight: 700;
`;

export const NoticeBody = styled.span`
    color: ${MUTED};
    font-size: 13px;
`;

export const ListCard = styled.div`
    border: 1px solid ${greys.border};
    border-radius: 12px;
    display: flex;
    flex-direction: column;
`;

export const ListRow = styled.div`
    align-items: center;
    display: flex;
    gap: 12px;
    padding: 12px 16px;

    & + & {
        border-top: 1px solid ${greys.border};
    }
`;

export const RowName = styled.span`
    color: ${INK};
    font-size: 13px;
    font-weight: 600;
`;

export const RowDetail = styled.span`
    color: ${MUTED};
    flex: 1;
    font-size: 13px;
`;

export const CarrierPill = styled.span`
    align-items: center;
    border: 1px solid ${greys.border};
    border-radius: 100px;
    color: ${MUTED};
    display: inline-flex;
    font-size: 11px;
    gap: 6px;
    padding: 4px 8px;

    &::before {
        background: ${INK};
        border-radius: 50%;
        content: '';
        height: 8px;
        width: 8px;
    }
`;
